import { render, staticRenderFns } from "./FlexibilitySegmentationVizualization.vue?vue&type=template&id=2308c779&scoped=true&"
import script from "./FlexibilitySegmentationVizualization.vue?vue&type=script&lang=js&"
export * from "./FlexibilitySegmentationVizualization.vue?vue&type=script&lang=js&"
import style0 from "./FlexibilitySegmentationVizualization.vue?vue&type=style&index=0&id=2308c779&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308c779",
  null
  
)

export default component.exports